import { useRef, useState, useEffect } from "react";
import ArrowLeft from "../assets/icons/ArrowLeft";
import ArrowRight from "../assets/icons/ArrowRight";
import Button from "./Button";
import WhiteCard from "./WhiteCard";
import ButtonNew from "./ButtonNew";


const ScrollingCards = ({ width, data, children, isButtonShow = true }) => {
    const scrollCards = useRef();
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);

    // Function to check scroll position and update arrow visibility
    const checkScrollPosition = () => {
        if (scrollCards.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollCards.current;

            // Show left arrow if not at the beginning
            setShowLeftArrow(scrollLeft > 0);

            // Show right arrow if not at the end (with small tolerance for rounding)
            setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
        }
    };

    // Check scroll position on mount and when children change
    useEffect(() => {
        checkScrollPosition();
    }, [children]);

    function scrollR() {
        scrollCards.current.scrollBy({
            left: 540,
            behavior: 'smooth',
        });
        // Check position after scroll animation completes
        setTimeout(checkScrollPosition, 300);
    }

    function scrollL() {
        scrollCards.current.scrollBy({
            left: -540,
            behavior: 'smooth',
        });
        // Check position after scroll animation completes
        setTimeout(checkScrollPosition, 300);
    }

    return (
        <div className="  ">
            <div className="">
                <div className="relative  ">
                    <WhiteCard shadow="" bg={'bg-none'} verticalMargin="" className="   ">
                        <div className={`h-full w-36 bg-right-gradient  absolute top-0 right-0 z-10 `}></div>


                        <div
                            ref={scrollCards}
                            onScroll={checkScrollPosition}
                            className={`flex  items-center overflow-x-auto    flex-nowrap   scrollableCards`}
                        >

                            {children}



                        </div>
                    </WhiteCard>

                    {isButtonShow && <>
                        {showLeftArrow && (
                            <ButtonNew
                                onClick={scrollL}
                                variant="closeNeutral"
                                size="xs"
                                shape="oval"
                                className="absolute top-[50%] translate-y-[-50%]   translate-x-[-50%] -left-0 py-3 "
                                fixedMinWidth
                                minWidthClass="min-w-[2.5rem]"
                            >
                                <ArrowLeft fillColor="#868686" />
                            </ButtonNew>


                        )}

                        {showRightArrow && (
                            <ButtonNew
                                onClick={scrollR}
                                variant="closeNeutral"
                                size="xs"
                                shape="oval"
                                className="absolute top-[50%] z-20 translate-y-[-50%] translate-x-[50%]  -right-0 py-3 "
                                fixedMinWidth
                                minWidthClass="min-w-[2.5rem]"
                            >
                                <ArrowRight fillColor={'#868686'} />
                            </ButtonNew>

                        )}
                    </>}
                </div>
            </div>
        </div>
    );
};

export default ScrollingCards;
